import { useState, useEffect } from "react";
import toast from "../../../utils/toast";
import { getPaymentInstrumentList } from "../../../services/propertyOwner/propertyOwnerServices";

export default function OwnerPaymentInstruments() {
  const [modesList, setModesList] = useState([]);
  const [listLoading, setListLoading] = useState(true);

  useEffect(() => {
    fetchModesList();
  }, []);

  const fetchModesList = async () => {
    setListLoading(true);
    try {
      const res = await getPaymentInstrumentList();
      if (res.statusCode === 1) setModesList(res.data);
    } catch (err) {
      console.log("Failed to fetch payment instruments");
    } finally {
      setListLoading(false);
    }
  };
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Payment Instruments
            </div>
            <div className="page-sub" id="page-sub">
              Configure your payment accounts shown to tenants
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="info-box mb16">
            <strong>My Payment Instruments</strong> — configure your accepted
            payment account details. Tenants will see these when submitting rent
            or payment requests. You can add multiple accounts per mode (e.g.
            multiple bank accounts).
          </div>
          <div className="card mb16">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 14,
                flexWrap: "wrap",
                gap: 8,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 22 }}>🏦</span>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>
                    Bank Transfer
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    2 instrument(s) — shown to tenants when they submit a
                    payment request
                  </div>
                </div>
              </div>
              <button
                className="btn btn-primary btn-sm"
                onclick="openInstrumentModal(1,null)"
              >
                + Add Bank Transfer
              </button>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "14px 1fr auto",
                gap: 12,
                alignItems: "start",
                padding: 14,
                background: "var(--bg-primary)",
                border: "0.5px solid var(--border-light)",
                borderRadius: "var(--radius-md)",
                marginBottom: 8,
              }}
            >
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "#3B6D11",
                  marginTop: 3,
                  flexShrink: 0,
                }}
              />
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>
                  HDFC Primary Account
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "130px 1fr",
                    gap: "3px 10px",
                    fontSize: 11,
                  }}
                >
                  <span style={{ color: "var(--text-tertiary)" }}>
                    Account Holder Name:
                  </span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    Sunrise Properties Pvt Ltd
                  </span>
                  <span style={{ color: "var(--text-tertiary)" }}>
                    Account Number:
                  </span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    50987654321
                  </span>
                  <span style={{ color: "var(--text-tertiary)" }}>
                    IFSC Code:
                  </span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    HDFC0001234
                  </span>
                  <span style={{ color: "var(--text-tertiary)" }}>
                    Bank Name:
                  </span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    HDFC Bank
                  </span>
                  <span style={{ color: "var(--text-tertiary)" }}>Branch:</span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    Koramangala, Bengaluru
                  </span>
                </div>
                <div
                  style={{ marginTop: 4, fontSize: 10, color: "var(--teal)" }}
                >
                  + 3 extra payer field(s): Remitter Name, Remitter Account No,
                  Transfer Type
                </div>
                <div style={{ marginTop: 3, fontSize: 10 }}>
                  <span style={{ color: "var(--amber)", fontWeight: 600 }}>
                    📷 Screenshot required
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 5,
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                <label className="toggle">
                  <input
                    type="checkbox"
                    defaultChecked=""
                    onchange="toggleInstrument(1,this.checked)"
                  />
                  <span className="toggle-slider" />
                </label>
                <button
                  className="btn btn-xs"
                  onclick="openInstrumentModal(1,1)"
                >
                  ✎ Edit
                </button>
                <button
                  className="btn btn-xs btn-danger"
                  onclick="deleteInstrument(1)"
                >
                  🗑
                </button>
              </div>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "14px 1fr auto",
                gap: 12,
                alignItems: "start",
                padding: 14,
                background: "var(--bg-secondary)",
                border: "0.5px solid var(--border-light)",
                borderRadius: "var(--radius-md)",
                marginBottom: 8,
              }}
            >
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "#ccc",
                  marginTop: 3,
                  flexShrink: 0,
                }}
              />
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>
                  SBI Secondary Account
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "130px 1fr",
                    gap: "3px 10px",
                    fontSize: 11,
                  }}
                >
                  <span style={{ color: "var(--text-tertiary)" }}>
                    Account Holder Name:
                  </span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    Sunrise Properties Pvt Ltd
                  </span>
                  <span style={{ color: "var(--text-tertiary)" }}>
                    Account Number:
                  </span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    40123456789
                  </span>
                  <span style={{ color: "var(--text-tertiary)" }}>
                    IFSC Code:
                  </span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    SBIN0012345
                  </span>
                  <span style={{ color: "var(--text-tertiary)" }}>
                    Bank Name:
                  </span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    State Bank of India
                  </span>
                  <span style={{ color: "var(--text-tertiary)" }}>Branch:</span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    Whitefield, Bengaluru
                  </span>
                </div>
                <div style={{ marginTop: 3, fontSize: 10 }}>
                  <span style={{ color: "var(--amber)", fontWeight: 600 }}>
                    📷 Screenshot required
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 5,
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                <label className="toggle">
                  <input
                    type="checkbox"
                    onchange="toggleInstrument(2,this.checked)"
                  />
                  <span className="toggle-slider" />
                </label>
                <button
                  className="btn btn-xs"
                  onclick="openInstrumentModal(1,2)"
                >
                  ✎ Edit
                </button>
                <button
                  className="btn btn-xs btn-danger"
                  onclick="deleteInstrument(2)"
                >
                  🗑
                </button>
              </div>
            </div>
          </div>
          <div className="card mb16">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 14,
                flexWrap: "wrap",
                gap: 8,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 22 }}>📱</span>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>
                    UPI Payment
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    1 instrument(s) — shown to tenants when they submit a
                    payment request
                  </div>
                </div>
              </div>
              <button
                className="btn btn-primary btn-sm"
                onclick="openInstrumentModal(2,null)"
              >
                + Add UPI Payment
              </button>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "14px 1fr auto",
                gap: 12,
                alignItems: "start",
                padding: 14,
                background: "var(--bg-primary)",
                border: "0.5px solid var(--border-light)",
                borderRadius: "var(--radius-md)",
                marginBottom: 8,
              }}
            >
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "#3B6D11",
                  marginTop: 3,
                  flexShrink: 0,
                }}
              />
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>
                  HDFC UPI
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "130px 1fr",
                    gap: "3px 10px",
                    fontSize: 11,
                  }}
                >
                  <span style={{ color: "var(--text-tertiary)" }}>UPI ID:</span>
                  <span style={{ fontWeight: 600, fontFamily: "monospace" }}>
                    sunrise.properties@hdfc
                  </span>
                </div>
                <div style={{ marginTop: 3, fontSize: 10 }}>
                  <span style={{ color: "var(--amber)", fontWeight: 600 }}>
                    📷 Screenshot required
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 5,
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                <label className="toggle">
                  <input
                    type="checkbox"
                    defaultChecked=""
                    onchange="toggleInstrument(3,this.checked)"
                  />
                  <span className="toggle-slider" />
                </label>
                <button
                  className="btn btn-xs"
                  onclick="openInstrumentModal(2,3)"
                >
                  ✎ Edit
                </button>
                <button
                  className="btn btn-xs btn-danger"
                  onclick="deleteInstrument(3)"
                >
                  🗑
                </button>
              </div>
            </div>
          </div>
          <div className="card mb16">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 14,
                flexWrap: "wrap",
                gap: 8,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 22 }}>📷</span>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>QR Code</div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    1 instrument(s) — shown to tenants when they submit a
                    payment request
                  </div>
                </div>
              </div>
              <button
                className="btn btn-primary btn-sm"
                onclick="openInstrumentModal(3,null)"
              >
                + Add QR Code
              </button>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "14px 1fr auto",
                gap: 12,
                alignItems: "start",
                padding: 14,
                background: "var(--bg-primary)",
                border: "0.5px solid var(--border-light)",
                borderRadius: "var(--radius-md)",
                marginBottom: 8,
              }}
            >
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "#3B6D11",
                  marginTop: 3,
                  flexShrink: 0,
                }}
              />
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>
                  Main QR Code
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "130px 1fr",
                    gap: "3px 10px",
                    fontSize: 11,
                  }}
                >
                  <span style={{ color: "var(--text-tertiary)" }}>
                    QR Code Image:
                  </span>
                  <span style={{ fontWeight: 600, fontFamily: "inherit" }}>
                    📷 Image uploaded
                  </span>
                </div>
                <div style={{ marginTop: 3, fontSize: 10 }}>
                  <span style={{ color: "var(--amber)", fontWeight: 600 }}>
                    📷 Screenshot required
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 5,
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                <label className="toggle">
                  <input
                    type="checkbox"
                    defaultChecked=""
                    onchange="toggleInstrument(4,this.checked)"
                  />
                  <span className="toggle-slider" />
                </label>
                <button
                  className="btn btn-xs"
                  onclick="openInstrumentModal(3,4)"
                >
                  ✎ Edit
                </button>
                <button
                  className="btn btn-xs btn-danger"
                  onclick="deleteInstrument(4)"
                >
                  🗑
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
